import React from 'react'
import {OurServiceData} from "../Home/OurService/OurServicesData";
import OurServiceCard from "../Home/OurService/OurServiceCard";

const VideoService = () => {
  return (
    <section id="service-slider" className="py100 bg-color">
    <div className="container">
        <div className="row">
            {OurServiceData.slice(12,17).map( (data, index)=>( <OurServiceCard data={data} key={index}/> ))}
        </div>
    </div>
</section>
  )
}

export default VideoService